'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleBlockType = require('./handleBlockType');

var _handleBlockType2 = _interopRequireDefault(_handleBlockType);

var _draftjsConstants = require('../../draftjsConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = function (char, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;

    var editorState = getEditorState();
    if (char !== ' ') return editorState;

    var newEditorState = (0, _handleBlockType2.default)(editorState, char);

    // TODO Inline markdown was erroneous.  Return to later
    // if (editorState === newEditorState) {
    //     newEditorState = handleInlineStyle(editorState, char);
    // }

    if (editorState !== newEditorState) {
        setEditorState(newEditorState);
        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
    }

    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
};
// import handleInlineStyle from './handleInlineStyle';

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/markdownSupport/handleBeforeInput.js
// module id = 1734
// module chunks = 0